import React from 'react';
import { ImageProps, Image as ReactNativeImage } from 'react-native';

type Props = ImageProps;

export const Image: React.FC<Props> = props => <ReactNativeImage {...props} />;
